import Constant from '@/const';
import axios from 'axios';

const getSubDistrict = async districtId => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(
        `/master/region/subdistrict?district=${districtId}`,
      ),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getSubDistrict;
